export const PASSWORD = '1.618'
export const LOGIN_SECTION = 'loginSection'
